export {default as ExplorerPage} from './ExplorerPage'
export {default as HomePage} from './HomePage'
export {default as InboxPage} from './InboxPage'
export {default as LoginPage} from './LoginPage'
export {default as PerfilPage} from './PerfilPage'
export {default as SignUpPage} from './SignUpPage'
export {default as SettingsPage} from './SettingsPage'
export {default as PublicationPage} from './PublicationPage'